import React from 'react';

interface WireIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const WireIcon: React.FC<WireIconProps> = ({ height, width, color = '#FFD700' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M467.7 109.08 251.47 17.51a6.65 6.65 0 0 0-5.18 0L32.41 109a6.23 6.23 0 0 0-3.8 5.74v41.14a6.26 6.26 0 0 0 6.25 6.24h430.47a6.06 6.06 0 0 0 6.06-6v-41.46a6 6 0 0 0-3.69-5.58m-7.58 41.83H39.88v-32.83l209-89.44 211.24 89.46ZM464.71 429.6H35.31a6.7 6.7 0 0 0-6.7 6.69v40a6.7 6.7 0 0 0 6.7 6.68h429.4a6.69 6.69 0 0 0 6.68-6.68v-40a6.69 6.69 0 0 0-6.68-6.69m-4.59 42.16H39.88v-30.9h420.24ZM115.61 209.9v-31.61a5.63 5.63 0 1 0-11.25 0v20.35H50.74v-20.35a5.63 5.63 0 1 0-11.26 0v31.61h15.36v173.16H39.48v31.6a5.63 5.63 0 1 0 11.26 0v-20.35h53.62v20.35a5.63 5.63 0 1 0 11.25 0v-31.6h-15.35V209.9ZM89 383.06H66.1V209.9H89ZM205.86 383.06v-11.7l-11.26-7.44v19.14h-22.89V348.8l-11-7.26a1.6 1.6 0 0 1-.25-.18v41.7h-15.37v31.6a5.63 5.63 0 0 0 11.26 0v-20.35H210v20.35a5.63 5.63 0 1 0 11.25 0v-31.6Zm9.74-210.4a5.63 5.63 0 0 0-5.62 5.63v20.35h-53.63v-20.35a5.63 5.63 0 0 0-11.26 0v31.61h15.37v27.38a20.44 20.44 0 0 1 10.95-3.15h.3V209.9h22.89v24.23h11.26V209.9h15.37v-31.61a5.63 5.63 0 0 0-5.63-5.63M339.56 383.06v-27.4a20.5 20.5 0 0 1-11 3.15h-.3v24.25H305.4v-24.25h-11.26v24.25h-15.36v31.6a5.63 5.63 0 1 0 11.25 0v-20.35h53.64v20.35a5.63 5.63 0 1 0 11.25 0v-31.6Zm9.73-210.4a5.63 5.63 0 0 0-5.62 5.63v20.35H290v-20.35a5.63 5.63 0 1 0-11.25 0v31.61h15.36v11.67L305.4 229v-19.1h22.9v34.23l11 7.27.26.18V209.9h15.36v-31.61a5.63 5.63 0 0 0-5.63-5.63M460.53 209.9v-31.61a5.63 5.63 0 1 0-11.25 0v20.35h-53.63v-20.35a5.63 5.63 0 1 0-11.26 0v31.61h15.37v173.16h-15.37v31.6a5.63 5.63 0 1 0 11.26 0v-20.35h53.63v20.35a5.63 5.63 0 1 0 11.25 0v-31.6h-15.36V209.9Zm-26.62 173.16H411V209.9h22.9Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M250 80.83a17.68 17.68 0 1 1-17.67 17.67A17.7 17.7 0 0 1 250 80.83m0-11.26a28.93 28.93 0 1 0 28.93 28.93A28.93 28.93 0 0 0 250 69.57M269.34 313.92a6.59 6.59 0 0 1-6.58-6.59v-24h11.44v14.92l44.88-29.63L274.2 239v14.06a6.59 6.59 0 0 1-6.58 6.59h-91.36v23.69h-11.44v-28.53a6.59 6.59 0 0 1 6.58-6.58h91.36V230a6.58 6.58 0 0 1 10.24-5.5l58.56 38.67a6.58 6.58 0 0 1 0 11L273 312.82a6.55 6.55 0 0 1-3.66 1.1"
      ></path>
      <path
        style={{ fill: color }}
        d="M230.66 369.54a6.6 6.6 0 0 1-3.62-1.09l-58.57-38.67a6.59 6.59 0 0 1 0-11L227 280.12a6.58 6.58 0 0 1 10.21 5.49v24H225.8v-14.96l-44.87 29.63 44.87 29.64v-14.07a6.59 6.59 0 0 1 6.59-6.58h91.35v-23.69h11.45v28.55a6.59 6.59 0 0 1-6.59 6.58h-91.35V363a6.6 6.6 0 0 1-6.59 6.59Z"
      ></path>
    </svg>
  );
};

export default WireIcon;
